export const ENROLL_CTA_ELEMENT_ID = "enroll-cta";
export const ENROLL_CTA_ANCHOR_HASH = "#enroll";
export const ENROLL_HIGHLIGHT_CLASS = "cv-enroll-highlight";
export const ENROLL_HIGHLIGHT_DURATION_MS = 2500;

/**
 * The Pokémon Card Vault promo announcement. Tracked by id so timestamp
 * changes don't accidentally drop us out of the special-cased toast branch.
 */
export const CARD_VAULT_ANNOUNCEMENT_ID = "10";

export const CARD_VAULT_PATH = "/card-vault";
